import { useEffect } from 'react'
import styled, { css } from 'styled-components'
import { Search, Divider } from 'semantic-ui-react'

import FlexRow from '@/ui/FlexRow'
import Icon from '@/ui/Icon'
import { ContentProps, OptionWrapperProps, TagProps } from './types'

interface TriggerWrapperProps {
  fullWidth?: boolean
  showTags?: boolean
  visible?: boolean
  disabled?: boolean
  margin?: string
}

export const FilterSearch = styled(props => {
  // The autoFocus prop on Search causes the window to scroll to the top.
  // So we have to use this hack instead.
  useEffect(() => {
    document?.querySelector<HTMLInputElement>('.popup input')?.focus({
      preventScroll: true,
    })
  }, [])

  return <Search {...props} showNoResults={false} />
})`
  &&& {
    div {
      width: 100%;
      border-bottom: 1px solid #dbe2e4;
    }

    input {
      font-family: 'Roboto';
      font-size: 14px;
      border: 0;
    }
  }
`

export const TriggerWrapper = styled.div<TriggerWrapperProps>`
  ${({ theme, fullWidth, showTags, visible, disabled, margin }) => css`
    display: flex;
    align-items: center;
    flex-wrap: ${showTags ? 'wrap' : 'no-wrap'};
    justify-content: ${showTags ? 'flex-start' : 'center'};
    height: ${fullWidth ? 'auto' : '37px'};
    min-height: 37px;
    background: ${disabled ? theme.colors.backgroundColor : '#fff'};
    border: 1px solid #bdcbd0;
    border-radius: 4px;
    padding: ${showTags ? '0.5em 1em' : '0 0.7em 0 1em'};
    width: ${fullWidth ? '100%' : '200px'};
    cursor: ${!visible ? 'default' : 'pointer'};
    color: rgba(0, 0, 0, 0.6);
    margin: ${margin ?? 0};
    > div {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `}
`

export const DropdownIcon = styled(Icon).attrs({
  button: true,
  name: 'icon-angle-down',
  size: 'large',
})`
  margin-right: 0 !important;
`

export const Content = styled.div<ContentProps>`
  ${({ width }) => css`
    width: ${width ? `${width}px` : '350px'};
  `}
`

export const OptionWrapper = styled(FlexRow).attrs({
  noMargin: true,
  alignItems: 'center',
})<OptionWrapperProps>`
  ${({ alignRight }) => css`
    &&&&&&& {
      .field {
        height: ${alignRight ? '20px' : 'auto'};
      }
      justify-content: ${alignRight ? 'flex-end' : 'flex-start'};
      input.hidden,
      .toggle {
        height: 15px;
        width: 25px;
      }
      .toggle.checked label {
        ::before {
          background-color: #ff9186 !important;
        }
        ::after {
          left: 10px;
        }
      }
      .toggle label {
        width: 25px;
        ::before {
          width: 25px;
          height: 15px;
        }
        ::after {
          width: 15px;
          height: 15px;
        }
      }
      .checkbox {
        position: relative;
        top: 2px;
      }
    }
  `}
`

export const Options = styled.div`
  height: 250px;
  overflow: auto;
  padding-bottom: 1em;

  ${OptionWrapper} {
    padding-top: 1em !important;
    padding-left: 1em !important;
    padding-right: 1em !important;
  }
`

export const OptionsDivider = styled(Divider)`
  &&& {
    margin: 1em;
    margin-bottom: 0;
  }
`

export const OptionLabel = styled.label`
  color: #012d3e;
  font-weight: 300;
  margin-left: 0.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`

export const Actions = styled(FlexRow).attrs({
  noMargin: true,
  alignItems: 'center',
})`
  padding: 0.75em 1em;
`

export const Tag = styled.span<TagProps>`
  ${({ excluded }) => css`
    display: flex;
    font-weight: 300;
    border-radius: 3px;
    line-height: 1;
    align-items: center;
    color: ${excluded ? '#FFF' : '#012D3E'};
    padding: 5px;
    background-color: ${excluded ? '#FF9186' : '#E5EAEB'};
    margin: 5px 10px 5px 0;
    svg {
      margin-bottom: 1px;
      margin-left: 5px;
    }
  `}
`

export const Placeholder = styled.span`
  font-size: 16px;
  color: #4d6c78;
  font-weight: 300;
`
